import { Card, CardBody, Col } from "reactstrap";
import NewUsersSocial from "./NewUsersSocial";
import { Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import LikeContent from "./LikeContent";
import SocialChat from "./SocialChat";
import CommentsBox from "./CommentsBox";

const NewUserClass = () => {
  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <NewUsersSocial />
          <Image className="img-fluid" alt="timeline" src={dynamicImage("social-app/timeline-1.png")}/>
          <div className="timeline-content">
            <P>The only way to do something in depth is to work hard. I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul.</P>
            <LikeContent />
            <SocialChat />
            <CommentsBox />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NewUserClass;
